module.exports = __webpack_public_path__ + "media/images/iconPaginateLast__accent-e76de163d1c14a43b313eaf3188e3813.png";